import React from "react";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import InfoDetail from "./InfoDetail";
import moment from "moment";
const { Panel } = Collapse;

const SystemInfo = (props) => {
  const { record } = props;

  const intl = useIntl();

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={[]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      className="custom-collapse-section"
    >
      <Panel
        header={intl.formatMessage({
          id: "app.leads.system_info",
        })}
        key={"1"}
      >
        <div>
          {record?.lead_owner && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.lead_owner",
              })}
              detail={record.lead_owner.name}
            />
          )}
          {record?.assigned_to && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.assigned_to",
              })}
              detail={record.assigned_to.name}
            />
          )}
          {record?.created_at && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.created_at",
              })}
              detail={moment(record.created_at).format("L")}
            />
          )}
        </div>
      </Panel>
    </Collapse>
  );
};
export default SystemInfo;
